import { Action } from 'redux';
import { AsignacionResponse } from '../../../models/Entities/Turnero';
import { TurneroAsignacionesState, TurneroAsignacionesUnloadState } from '../../states/Turnero-Asignaciones.State';

export default function TurneroAsignacionesReducer(
    state: TurneroAsignacionesState | undefined,
    action: Action
): TurneroAsignacionesState {
    const currentState = state ?? TurneroAsignacionesUnloadState;
    const a: any = action;

    switch (a.type) {
        case 'TURNERO-ASIGNACIONES_ASIGNAR_REQUEST':
            return {
                ...currentState,
                isAssigning: true,
                successAssigning: false,
                failOnAssigning: false,
                error: undefined
            } as TurneroAsignacionesState;
        case 'TURNERO-ASIGNACIONES_ASIGNAR_SUCCESS': {
            const updatedList: AsignacionResponse[] = [...(currentState.list || [])].filter(item => item.id !== a.payload.id);
            updatedList.push(a.payload);
            return {
                ...currentState,
                isAssigning: false,
                successAssigning: true,
                failOnAssigning: false,
                error: undefined,
                list: updatedList
            } as TurneroAsignacionesState;
        }
        case 'TURNERO-ASIGNACIONES_ASIGNAR_FAILURE':
            return {
                ...currentState,
                isAssigning: false,
                successAssigning: false,
                failOnAssigning: true,
                error: a.error
            } as TurneroAsignacionesState;

        case 'TURNERO-ASIGNACIONES_LIBERAR_REQUEST':
            return {
                ...currentState,
                isLiberating: true,
                successLiberating: false,
                failOnLiberating: false,
                error: undefined
            } as TurneroAsignacionesState;
        case 'TURNERO-ASIGNACIONES_LIBERAR_SUCCESS': {
            const filtered = (currentState.list || []).filter((item: AsignacionResponse) => item.medico?.id !== a.medicoId);
            return {
                ...currentState,
                isLiberating: false,
                successLiberating: true,
                failOnLiberating: false,
                error: undefined,
                list: filtered
            } as TurneroAsignacionesState;
        }
        case 'TURNERO-ASIGNACIONES_LIBERAR_FAILURE':
            return {
                ...currentState,
                isLiberating: false,
                successLiberating: false,
                failOnLiberating: true,
                error: a.error
            } as TurneroAsignacionesState;

        case 'TURNERO-ASIGNACIONES_GET_ACTIVAS_REQUEST':
            return {
                ...currentState,
                isLoadingActivas: true,
                successLoadingActivas: false,
                failOnLoadingActivas: false,
                error: undefined
            } as TurneroAsignacionesState;
        case 'TURNERO-ASIGNACIONES_GET_ACTIVAS_SUCCESS':
            return {
                ...currentState,
                isLoadingActivas: false,
                successLoadingActivas: true,
                failOnLoadingActivas: false,
                error: undefined,
                list: a.payload || []
            } as TurneroAsignacionesState;
        case 'TURNERO-ASIGNACIONES_GET_ACTIVAS_FAILURE':
            return {
                ...currentState,
                isLoadingActivas: false,
                successLoadingActivas: false,
                failOnLoadingActivas: true,
                error: a.error
            } as TurneroAsignacionesState;

        default:
            return currentState as TurneroAsignacionesState;
    }
}
